<template>
  <span :class="['label', `label-optimiser-sheet-status-${status}`]">{{status | formatLookupName(OptimiserSheetStatusTypeLookup)}}</span>
</template>

<script>
import { OptimiserSheetStatusTypeLookup } from '@/store/types'

export default {
  name: 'LabelSheetStatusBadge',
  props: {
    status: String
  },
  created() {
    this.OptimiserSheetStatusTypeLookup = OptimiserSheetStatusTypeLookup
  },
}
</script>
